import React, { useEffect, useState } from "react";
import { handleError, handleSuccess } from "../../../Utils";
import { useSearchParams } from "react-router-dom";
import {
  getMentorDataForUserReview,
  review,
} from "../../../ApiServices/ApiServices";
import dummyProfileImage from "../../../assets/dummy-profile-pic.png";

function ReviewForm() {
  const [mentorName, setMentorName] = useState("");
  const [mentorEmail, setMentorEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [experience, setExperience] = useState("");
  const [rating, setRating] = useState("");
  const [experienceError, setExperienceError] = useState("");
  const [ratingError, setRatingError] = useState("");
  const [profileImage, setProfileImage] = useState({
    url: "",
    filename: "",
    contentType: "",
    size: 0,
  });
  const [regards, setRegards] = useState("");
  const [isRatingDone, setIsRatingDone] = useState(false);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataForReview = await getMentorDataForUserReview(id);
        setMentorName(dataForReview?.data?.mentor_name);
        setMentorEmail(dataForReview?.data?.mentor_email);
        setUserName(dataForReview?.data?.user_name);
        setUserEmail(dataForReview?.data?.user_email);
        if (dataForReview?.profileImage) {
          setProfileImage({
            url: dataForReview.profileImage.url,
            filename: dataForReview.profileImage.filename,
            contentType: dataForReview.profileImage.contentType,
            size: dataForReview.profileImage.size,
          });
        }
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }finally{
        setLoading(false);
      }
    };
    if(id){
      fetchData();
    }
    setIsRatingDone(localStorage.getItem("isRatingDone"))
    setRegards(localStorage.getItem(`regards${id}`));
  }, [id]);

  const handleExperienceChange = (e) => {
    setExperience(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!rating) {
        setRatingError("Please rate your experience");
        setTimeout(() => {
          setRatingError("");
        }, 2000);
        return;
      }

      if (!experience) {
        setExperienceError("Please input your experience");
        setTimeout(() => {
          setExperienceError("");
        }, 2000);
        return;
      }
      // Data to be sent to the backend
      const reviewData = {};
      reviewData.mentorEmail = mentorEmail;
      reviewData.mentorName = mentorName;
      reviewData.userEmail = userEmail;
      reviewData.userName = userName;
      reviewData.experience = experience;
      reviewData.rating = rating;
      const res = await review(reviewData);
      setExperience("");
      setRating("");
      setRegards(res?.message);
      setIsRatingDone(true);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  if (loading) return <p>Loading profile...</p>;
  return (
    <div className="bg-blue-300 min-h-screen flex items-center justify-center py-6 sm:py-12">
      <div className="bg-white rounded-lg p-6 sm:p-8 w-full sm:w-96 max-w-lg">
        {!isRatingDone? (
          <div>
            {/* Image */}
            <div className="text-center mb-4">
              <img
                src={profileImage.url || dummyProfileImage}
                alt="User"
                className="rounded-full mx-auto mb-2 w-24 h-24 object-cover"
              />
              <p className="font-semibold text-xl">{mentorName}</p>
            </div>

            {/* Experience Rating */}
            <div className="text-center mb-4">
              <p className="text-lg text-gray-700 font-semibold">
                Please rate your experience
              </p>
              <div className="flex justify-center mt-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg
                    key={star}
                    onClick={() => setRating(star)}
                    className={`h-10 w-10 cursor-pointer ${
                      star <= rating ? "text-yellow-500" : "text-gray-300"
                    }`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill={star <= rating ? "currentColor" : "none"}
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 17l5 3-1.5-5.5L21 9h-6.5L12 2 9.5 9H3l4.5 4.5L7 20z"
                    />
                  </svg>
                ))}
              </div>
              <p className="text-red-500 text-sm mt-1">{ratingError}</p>
            </div>

            {/* Feedback Textarea */}
            <div className="mb-4">
              <label className="text-sm block text-gray-800 text-left">
                Tell us about your experience
              </label>
              <textarea
                className="w-full mt-2 p-2 border rounded-md"
                rows="4"
                value={experience}
                onChange={handleExperienceChange}
                placeholder="Tell us what you loved..."
              />
              {experienceError && (
                <p className="text-red-500 text-sm mt-1">{experienceError}</p>
              )}
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                onClick={handleSubmit}
                className="bg-black text-white py-2 px-4 rounded-md font-bold w-full"
              >
                Submit
              </button>
            </div>
          </div>
        ) : (
          <div className="text-center">{regards}</div>
        )}
      </div>
    </div>
  );
}

export default ReviewForm;
